import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/common.css'
import "./plugins/video.js"; // 引入刚刚定义的video.js文件
import SlideVerify from 'vue-monoplasty-slide-verify';

Vue.config.productionTip = false
Vue.config.productionGzip = true

Vue.use(ElementUI);
Vue.use(SlideVerify);

router.beforeEach((to, from, next) => {
	/* 路由发生变化修改页面title */
	if (to.meta.title) {
		const name = localStorage.getItem('webName')
		document.title = name + '-' + to.meta.title
	}
	// console.log(1254454)
	// console.log(to)
	// console.log(585588)
	// console.log(from)
	next();
});

Vue.prototype.$bus = new Vue()


new Vue({
	router,
	render: h => h(App),
}).$mount('#app')
